@if(video) {
<div class="container">
  <div class="row">
    <div class="col-md-12 ">
      <h5 class="border-bottom mt-5 mb-3">FEATURED VIDEO</h5>
    </div>
    <div class="col-md-5">
      <a class="videoTitle" routerLink="/videos/{{video.friendlyUrl}}">
        <!-- <div class="position-relative"> -->
        <img class="img-fluid w-100" fetchpriority="high"
          src="{{video.video?'https://services.ifa.com/videos/images/512x288_c_'+video.video+'_q80.webp':video.imageUrl}}"
          alt="{{video.title}}" width="512" height="288" />
        <!-- <div class="premiumContent" [ngClass]="{'unlocked':globals.isLoggedIn}" *ngIf="!video.approval_whitelist"><fa-icon [icon]="['fas', 'plus-circle']" class="mx-2"></fa-icon></div> -->
        <!-- </div> -->
        <!-- <div class="new_play text-center">&#9654;</div> -->
        <!-- <div class="btn btn-success d-block mt-2 py-3 small rounded-0 text-decoration-none" >WATCH VIDEO <fa-icon [icon]="['fas','video']"></fa-icon></div> -->
      </a>
    </div>
    <div class="col-md-7">

      <div class="ps-sm-2">
        <a class="videoTitle text-decoration-none fs-3 text-dark" routerLink="/videos/{{video.friendlyUrl}}">
          <h3>{{video.title}}</h3>
        </a>
        <div *ngIf="video.views != undefined && video.views > 0" class="small">
          {{video.views == undefined ? 0 : video.views|number}} views
        </div>

        <em class="d-block small">by {{video.author}}</em>
        <em class="d-block small mb-3">
          <!-- <span *ngIf="video.date_originally_published!=video.date">Updated: </span> -->
          {{video.date | date:'EEEE, MMMM dd, yyyy'}}
        </em>

        <div class="small">
          <div class="d-inline" [innerHTML]="video.description|safe:'html'"></div>&nbsp;
          <a routerLink="/videos/{{video.friendlyUrl}}">&#8230;Watch Video</a>
        </div>
      </div>
    </div>
  </div>
</div>
}


@if(videos && videos.length>0) {
  <div class="container justify-content-center text-align-start">
    <div class="row">
      <div class="col">
        @for(category of videos; track category; let cidx = $index) 
        {
          @if((category.description=='Recent Videos' && category.videos.length>1) || category.description!='Recent Videos') {
          
            <hr>
            <h3>{{category.description}}</h3>
            <div class="d-flex flex-nowrap flex-sm-wrap justify-content-sm-start scrollSection">
              @for(a of category.videos; track a; let i = $index) 
              {

                
                <app-video-card [video]="a"></app-video-card>
              }

              @for(p of category.people; track p; let i = $index) 
              {
                <div class="videoCard mb-4">
                  <div class="me-md-3 videoThumb minw256">
                    <a href="{{p.shareUrl}}">
                      <img loading="lazy" class="img-fluid" width="256" height="144" [src]="p.imageUrl" alt="{{p.name}}" />
                    </a>
                  </div>
                  <div class="text-center">
                    <a class="videoTitle" href="{{p.shareUrl}}">
                      <div class="person-name"><span style="font-weight:400">{{p.name}}</span></div>
                    </a>
                  </div>
                </div>
              }
            </div>
            }
        }
      </div>
    </div>
  </div>
}